<template>
  <div class="points-quota-container">
    <!-- 头部卡片 -->
    <el-row :gutter="20" class="header-cards">
      <!-- 积分卡片 -->
      <el-col :xs="24" :sm="12" :md="6">
        <el-card class="card-points">
          <div class="card-header">
            <span class="icon">💰</span>
            <span class="title">我的积分</span>
          </div>
          <div class="card-value">{{ userPoints }}</div>
          <div class="card-desc">总积分: {{ totalPoints }}</div>
        </el-card>
      </el-col>

      <!-- 配额使用卡片 -->
      <el-col :xs="24" :sm="12" :md="6">
        <el-card class="card-quota">
          <div class="card-header">
            <span class="icon">📊</span>
            <span class="title">月度配额</span>
          </div>
          <div class="card-value">{{ remainingQuota }}</div>
          <div class="card-desc">总配额: {{ monthlyQuota }}</div>
        </el-card>
      </el-col>

      <!-- 配额进度 -->
      <el-col :xs="24" :sm="12" :md="6">
        <el-card class="card-progress">
          <div class="card-header">
            <span class="icon">📈</span>
            <span class="title">使用进度</span>
          </div>
          <el-progress :percentage="usagePercentage" :color="progressColor"></el-progress>
          <div class="card-desc">已使用 {{ quotaUsage }} / {{ monthlyQuota }}</div>
        </el-card>
      </el-col>

      <!-- 配额重置日期 -->
      <el-col :xs="24" :sm="12" :md="6">
        <el-card class="card-reset">
          <div class="card-header">
            <span class="icon">🔄</span>
            <span class="title">重置日期</span>
          </div>
          <div class="card-value">{{ quotaResetDate }}</div>
          <div class="card-desc">距离下次重置</div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 选项卡 -->
    <el-tabs v-model="activeTab" class="tabs-section">
      <!-- 积分交易历史 -->
      <el-tab-pane label="积分交易记录" name="points">
        <el-table :data="pointsHistory" v-loading="pointsLoading" stripe>
          <el-table-column prop="id" label="ID" width="60"></el-table-column>
          <el-table-column prop="points" label="变化" width="100">
            <template #default="{ row }">
              <span :class="['points-change', row.points > 0 ? 'add' : 'subtract']">
                {{ row.points > 0 ? '+' : '' }}{{ row.points }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="reason" label="原因" width="100"></el-table-column>
          <el-table-column prop="balance_after" label="余额"></el-table-column>
          <el-table-column prop="created_at" label="时间" width="180"></el-table-column>
          <el-table-column prop="description" label="描述"></el-table-column>
        </el-table>
        <el-pagination
          @current-change="handlePointsPageChange"
          :current-page="pointsPage"
          :page-size="pageSize"
          :total="pointsTotal"
          layout="total, prev, pager, next"
          class="pagination"
        ></el-pagination>
      </el-tab-pane>

      <!-- 配额使用历史 -->
      <el-tab-pane label="配额使用记录" name="quota">
        <el-table :data="quotaHistory" v-loading="quotaLoading" stripe>
          <el-table-column prop="id" label="ID" width="60"></el-table-column>
          <el-table-column prop="platform" label="平台" width="100"></el-table-column>
          <el-table-column prop="operation_type" label="操作" width="100"></el-table-column>
          <el-table-column prop="quota_cost" label="消耗" width="80">
            <template #default="{ row }">
              <span class="quota-cost">-{{ row.quota_cost }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remaining_quota" label="剩余"></el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template #default="{ row }">
              <el-tag :type="row.status === 'success' ? 'success' : 'danger'">
                {{ row.status }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="时间" width="180"></el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleQuotaPageChange"
          :current-page="quotaPage"
          :page-size="pageSize"
          :total="quotaTotal"
          layout="total, prev, pager, next"
          class="pagination"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PointsQuota',
  data() {
    return {
      activeTab: 'points',
      pageSize: 20,

      // 积分数据
      userPoints: 0,
      totalPoints: 0,
      pointsHistory: [],
      pointsLoading: false,
      pointsPage: 1,
      pointsTotal: 0,

      // 配额数据
      monthlyQuota: 0,
      quotaUsage: 0,
      remainingQuota: 0,
      usagePercentage: 0,
      quotaResetDate: '',
      quotaHistory: [],
      quotaLoading: false,
      quotaPage: 1,
      quotaTotal: 0
    }
  },

  computed: {
    progressColor() {
      if (this.usagePercentage < 50) return '#67C23A'
      else if (this.usagePercentage < 80) return '#E6A23C'
      else return '#FF4949'
    }
  },

  mounted() {
    this.loadPointsData()
    this.loadQuotaData()
  },

  methods: {
    async loadPointsData() {
      this.pointsLoading = true
      try {
        // 获取积分余额
        const balanceRes = await axios.get('/user/points/balance')
        this.userPoints = balanceRes.data.current_points
        this.totalPoints = balanceRes.data.total_points

        // 获取积分历史
        const historyRes = await axios.get('/user/points/history', {
          params: {
            limit: this.pageSize,
            offset: (this.pointsPage - 1) * this.pageSize
          }
        })
        this.pointsHistory = historyRes.data.data
        this.pointsTotal = historyRes.data.total
      } catch (error) {
        this.$message.error('加载积分数据失败：' + (error.response?.data?.detail || error.message))
      } finally {
        this.pointsLoading = false
      }
    },

    async loadQuotaData() {
      this.quotaLoading = true
      try {
        // 获取配额信息
        const quotaRes = await axios.get('/user/quota/info')
        this.monthlyQuota = quotaRes.data.crawler_quota
        this.quotaUsage = quotaRes.data.crawler_usage
        this.remainingQuota = quotaRes.data.remaining_quota
        this.usagePercentage = quotaRes.data.usage_percentage
        this.quotaResetDate = new Date(quotaRes.data.quota_reset_date).toLocaleDateString()

        // 获取配额历史
        const historyRes = await axios.get('/user/quota/history', {
          params: {
            limit: this.pageSize,
            offset: (this.quotaPage - 1) * this.pageSize
          }
        })
        this.quotaHistory = historyRes.data.data
        this.quotaTotal = historyRes.data.total
      } catch (error) {
        this.$message.error('加载配额数据失败：' + (error.response?.data?.detail || error.message))
      } finally {
        this.quotaLoading = false
      }
    },

    handlePointsPageChange(page) {
      this.pointsPage = page
      this.loadPointsData()
    },

    handleQuotaPageChange(page) {
      this.quotaPage = page
      this.loadQuotaData()
    }
  }
}
</script>

<style scoped>
.points-quota-container {
  padding: 20px;
}

.header-cards {
  margin-bottom: 30px;
}

.card-points,
.card-quota,
.card-progress,
.card-reset {
  border-radius: 8px;
  transition: all 0.3s ease;
}

.card-points:hover,
.card-quota:hover,
.card-progress:hover,
.card-reset:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.icon {
  font-size: 24px;
  margin-right: 10px;
}

.title {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.card-value {
  font-size: 32px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 10px;
}

.card-points .card-value {
  color: #409eff;
}

.card-quota .card-value {
  color: #67c23a;
}

.card-desc {
  font-size: 12px;
  color: #909399;
}

.tabs-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.points-change {
  font-weight: bold;
  font-size: 14px;
}

.points-change.add {
  color: #67c23a;
}

.points-change.subtract {
  color: #f56c6c;
}

.quota-cost {
  color: #f56c6c;
  font-weight: bold;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
